// extracted by mini-css-extract-plugin
module.exports = {"deleteBttn":"AttributeLine_deleteBttn__2mIEv","attributeNameInput":"AttributeLine_attributeNameInput__1--Nv"};